'use client';

import { Button } from '@ui/components/button';
import { cn } from '@ui/lib/utils';
import { text } from '@modules/garden-planner/text';
import { useRef, useEffect } from 'react';
import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faTrash } from '@micks-yard/icons/solid/faTrash';

interface ClearPlantsToolViewProps {
  isActive: boolean;
  onToggle: () => void;
  onClearAllPlants: () => Promise<void>;
}

export function ClearPlantsToolView({
  isActive,
  onToggle,
  onClearAllPlants,
}: ClearPlantsToolViewProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [isActive]);

  return (
    <div ref={ref}>
      <Button
        type="button"
        variant={isActive ? 'ghost' : 'outline'}
        className={cn(
          'w-full justify-start gap-2',
          isActive && 'bg-orange-100 text-orange-800 hover:bg-orange-200 hover:text-orange-800'
        )}
        onClick={onToggle}>
        <FaIcon icon={faTrash} className="size-4" />
        {isActive ? text.exitClearMode : text.clearPlants}
      </Button>

      {isActive ? (
        <div className="bg-muted mt-2 flex flex-col gap-2 rounded-r-md border-l-4 border-l-orange-500 py-3 pr-3 pl-3">
          <p className="text-muted-foreground text-sm">{text.clearPlantsHint}</p>
          <Button
            type="button"
            variant="destructive"
            className="w-full"
            size="sm"
            onClick={() => void onClearAllPlants()}>
            {text.clearAllPlants}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
